import styled from 'styled-components';
import { useAppDispatch } from '../../../../redux/hooks';
import { setChartSettingYAxisConfigAction } from '../../../../redux/slices/analyses';
import { assertNotNil } from '../../../../utils/types';
import SegmentSelect from '../../../SegmentSelect';
import { useChartContext } from '../../ChartContext';
import { YAxisPosition } from '../../interfaces';
import {
  AssignmentLabel,
  AssignmentRowWrapper,
} from '../CentralChartSettingUI';
import { AssignmentContainer } from '../CentralChartSettingUI';
import { YAxisFormatAssignment } from '.';
import YAxisBoundAssignment from './YAxisBoundAssignment';
import {
  AxisOptionType,
  CentralChartSettingAccordionType,
  ICentralChartSettingOptions,
} from '../hooks/utils';
import { Y_AXIS_VISIBILITY_OPTIONS } from './utils';
interface IProps {
  yAxisPosition: YAxisPosition;
  assignmentConfigs: ICentralChartSettingOptions;
}

const StyledSegmentSelect = styled(SegmentSelect<boolean>)`
  flex: 1;
`;

const YAxisAssignments = ({ yAxisPosition, assignmentConfigs }: IProps) => {
  const dispatch = useAppDispatch();
  const {
    metadata: { analysisId },
    settings: {
      chartSettings: { axisSettings },
    },
  } = useChartContext();

  const { yAxisSettings } = axisSettings;
  const currentYAxisSettings = yAxisSettings[yAxisPosition];
  assertNotNil(currentYAxisSettings);

  const onYAxisVisibilityChange = (isVisible: boolean) => {
    dispatch(
      setChartSettingYAxisConfigAction({
        analysisId,
        yAxisPosition,
        config: {
          isVisible,
        },
      }),
    );
  };

  const accordionType =
    yAxisPosition === YAxisPosition.LEFT
      ? CentralChartSettingAccordionType.LeftYAxisAssignments
      : CentralChartSettingAccordionType.RightYAxisAssignments;
  const isFormatAssignmentVisible =
    !!assignmentConfigs[accordionType]?.[AxisOptionType.Format];

  const isBoundsAssignmentVisible =
    !!assignmentConfigs[accordionType]?.[AxisOptionType.Bounds];

  return (
    <AssignmentContainer>
      <AssignmentRowWrapper>
        <AssignmentLabel>Axis</AssignmentLabel>
        <StyledSegmentSelect
          options={Y_AXIS_VISIBILITY_OPTIONS}
          value={currentYAxisSettings.isVisible}
          onChange={(value) => onYAxisVisibilityChange(value)}
        />
      </AssignmentRowWrapper>
      {isFormatAssignmentVisible && (
        <YAxisFormatAssignment yAxisPosition={yAxisPosition} />
      )}
      {isBoundsAssignmentVisible && (
        <YAxisBoundAssignment yAxisPosition={yAxisPosition} />
      )}
    </AssignmentContainer>
  );
};

export default YAxisAssignments;
